import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Amplitude from "@Shared/utils/amplitude";
import TimelineEmailContactList from "../timeline-email-contact-list";
import RichTextEditor from "@Shared/utils/rich-text-editor";
import SpinnerLoader from "@Shared/utils/preload";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "EmailConvert",
  components: {
    TimelineEmailContactList
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    subject: {
      type: String,
      default: ""
    },
    from: {
      type: String,
      default: ""
    },
    threadId: {
      type: String,
      default: ""
    },
    messageId: {
      type: String,
      default: ""
    },
    toList: {
      type: Object,
      default: () => ({})
    },
    ccList: {
      type: Object,
      default: () => ({})
    },
    bccList: {
      type: Object,
      default: () => ({})
    },
    filesList: {
      type: Object,
      default: () => ({})
    },
    body: {
      type: String,
      default: ""
    },
    opens: {
      type: Number,
      default: null
    },
    clicks: {
      type: Number,
      default: null
    },
    updatedAt: {
      type: String,
      default: ""
    },
    createdAt: {
      type: String,
      default: ""
    },
    read: {
      type: Boolean,
      default: null
    },
    openedAt: {
      type: String,
      default: ""
    },
    clientProfileId: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    fromName() {
      var _context;
      return _trimInstanceProperty(_context = this.from.split("<")[0] || "").call(_context);
    },
    fromEmail() {
      var _context2;
      return _trimInstanceProperty(_context2 = this.from.split("<")[1] || "").call(_context2);
    }
  },
  mounted() {
    this.prepareEmail();
  },
  methods: {
    hasFiles(filesList) {
      return _filterInstanceProperty(filesList).call(filesList, file => file.filename).length > 0;
    },
    async loadEmailIntoHTML(htmlString, target) {
      SpinnerLoader.start(target);
      return new _Promise(resolve => {
        window.requestAnimationFrame(() => {
          try {
            const htmlNode = document.createElement("html");
            htmlNode.innerHTML = RichTextEditor.sanitizeHtml(htmlString);
            htmlNode.querySelectorAll("base").forEach(meta => {
              meta.remove();
            });
            htmlNode.querySelectorAll("a").forEach(anchor => {
              anchor.target = "_blank";
            });
            const iframe = $("<iframe class='email-iframe' scrolling='no' frameborder='0' width='100%' height='100%'>")[0];
            target.prepend(iframe);
            const iframeDocument = iframe.contentWindow.document;
            iframeDocument.open();
            iframeDocument.write(htmlNode.innerHTML);
            iframeDocument.close();
            resolve();
            SpinnerLoader.stop(target);
          } catch (e) {
            Amplitude.logHandledError(e);
            SpinnerLoader.start(target, {
              error: true
            });
            resolve();
          }
        });
      });
    },
    async prepareEmail() {
      var _context3;
      const targetContainer = _findInstanceProperty(_context3 = $(this.$refs.container)).call(_context3, `#email-${this.id}`);
      if (_findInstanceProperty(targetContainer).call(targetContainer, "iframe").exists()) return;
      const {
        files
      } = this.filesList;
      let body = this.body;
      files.forEach(file => {
        body = _replaceAllInstanceProperty(body).call(body, "cid:" + file.content_id, file.displayUrl);
      });
      return await this.loadEmailIntoHTML(body, targetContainer);
    },
    resizeIFrame() {
      var _context4;
      const iframeNode = _findInstanceProperty(_context4 = $(this.$refs.emailWrapper)).call(_context4, "iframe")[0];
      let offsetHeight = null;
      try {
        offsetHeight = iframeNode.contentWindow.document.querySelector("body").offsetHeight;
      } catch (error) {
        offsetHeight = iframeNode.contentWindow.document.body.offsetHeight;
      }
      iframeNode.style.height = offsetHeight + 15 + "px";
      return offsetHeight;
    },
    showEmailCC(event) {
      const target = $(event.currentTarget);
      const container = target.parent(".show-email-cc-wrapper");
      const toggleTarget = container.children(".show-email-cc-target");
      const toggleTargetIsVisible = toggleTarget.is(":visible");
      toggleTarget.slideToggle();
      if (toggleTargetIsVisible) {
        target.html("<i class='fa fa-caret-down' aria-hidden='true'></i>");
      } else {
        target.html("<i class='fa fa-caret-up' aria-hidden='true'></i>");
      }
    }
  }
});